'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagIqAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.72989e-05 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20C0 13.3333 -0.000175947 6.66667 2.72989e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 6.66667H28V0H2.72989e-05L0 6.66667Z",
          fill: "#DF1E35"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V13.3333H0V20Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10.6667 8.53933C10.6667 8.29154 10.9275 8.13037 11.1491 8.24119L11.8158 8.57452C11.9287 8.63099 12 8.74641 12 8.87266V11.6667C12 11.8507 11.8508 12 11.6667 12L8.33333 12C8.14924 12 8 11.8508 8 11.6667V10.206C8 10.0797 8.07133 9.96432 8.18426 9.90786L8.85093 9.57453C9.07256 9.46371 9.33333 9.62487 9.33333 9.87267V10.7264H10.6667V8.53933Z",
          fill: "#0F7A40"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M18.6667 8.53933C18.6667 8.29154 18.9275 8.13037 19.1491 8.24119L19.8158 8.57452C19.9287 8.63099 20 8.74641 20 8.87266V11.6667C20 11.8507 19.8508 12 19.6667 12H19C18.8159 12 18.6667 11.8507 18.6667 11.6667V8.53933Z",
          fill: "#0F7A40"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16.1843 8.57452C16.0713 8.63099 16 8.74641 16 8.87266V10.7264H14.6666V9.87267C14.6666 9.62487 14.4059 9.46371 14.1842 9.57453L13.5176 9.90786C13.4046 9.96432 13.3333 10.0797 13.3333 10.206V11.6667C13.3333 11.8508 13.4826 12 13.6666 12L17 12C17.1841 12 17.3333 11.8507 17.3333 11.6667V8.53933C17.3333 8.29154 17.0726 8.13037 16.8509 8.24119L16.1843 8.57452Z",
          fill: "#0F7A40"
        }
      )
    ]
  }
);
const VpFlagIqAsset = forwardRef(FlagIqAsset);

export { VpFlagIqAsset as default };
